import gql from 'graphql-tag';

const getMenuItems = gql`
  query GetMenuItems {
    menuItems {
      id
      icon
      url
      text
      active
      disabled
    }
  }
`;

export default getMenuItems;
